import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['body']

  connect() {
    this.bodyTarget.classList.add('d_n');
  }

  toggle() {
    this.bodyTarget.classList.toggle('d_n');
  }
}
